/* eslint-disable react/no-unknown-property */
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Box, Image, Heading } from 'theme-ui'
import { NavBar } from '/components/layout/NavBar'
import { NavMobile } from '/components/layout/NavMobile'
import { LanguageSwitch } from '/components/layout/LanguageSwitch'
import styles from './styles'
import useResponsive from '/hooks/useResponsive'

export const HeaderV2 = ({ sideMenu, layout, languageSwitch, ...props }) => {
  const { isMobile } = useResponsive(props.isMobile)

  return (
    <header sx={styles.header}>
      {isMobile ? (
        <NavMobile navItems={sideMenu} />
      ) : (
        <NavBar navItems={sideMenu} />
      )}
      {languageSwitch && (
        <LanguageSwitch isMobile={isMobile} languageSwitch={languageSwitch} />
      )}
      {layout?.backgroundImage && (
        <Box sx={styles.imageContainer}>
          <Image
            sx={styles.headerImage}
            {...props}
            src={layout?.backgroundImage}
          />
          <Box sx={styles.overlay} />
        </Box>
      )}
      <Box sx={styles.titleContainer}>
        <Heading
          as="h2"
          sx={{ ...styles.title, variant: `text.headerTopTitle` }}
        >
          {layout?.topTitle}
        </Heading>
        <Heading
          as="h2"
          sx={{ ...styles.bottomTitle, variant: `text.headerBottomTitle` }}
        >
          {layout?.bottomTitle}
        </Heading>
      </Box>
    </header>
  )
}
